import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ProfileDataBlock extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array
    ]),
    heading: PropTypes.string
  }

  renderHeading(heading) {
    return heading ?
      (
        <h3 className="profile-data-block-heading">
          {heading}
        </h3>
      ) : '';
  }

  render() {
    const { children, heading } = this.props;

    return (
      <div className="profile-data-block">
        {this.renderHeading(heading)}
        <div className="profile-data-block-content">
          {children}
        </div>
      </div>
    );
  }
}

export default ProfileDataBlock;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileDataBlock.js